import VueI18n from "vue-i18n";
import Vue from "vue";
//import ru from "@/lang/ru.json";
import uk from "@/lang/uk.json";
import en from "@/lang/en.json";
const selectedLocale = localStorage.getItem("selectedLocale");

console.log("selectedLocale", selectedLocale);

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: selectedLocale || "uk",
  messages: {
    en,
    uk,
  },
});

export default i18n;
